export const INITIATE_AUTH = "INITIATE_AUTH";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const SET_LOGGED_OUT = "SET_LOGGED_OUT";
export const SET_ADMIN = "SET_ADMIN"
export const SET_USER = "SET_USER"